<div [classList]="border? 'border card' : 'card'" (click)="redirectToEvent()" [class.hovered]="mouseOvered"
     (animationstart)="mouseOvered=true" (animationcancel)="mouseOvered=false">
    <div class="img-container">
      <img class="img" ngSrc="{{ relativeUrl() }}" fill alt="Thumbnail foto van activiteit: {{ event.name }}" placeholder priority>
      <div class="tag {{ event.category | lowercase }}">
        <img src="assets/img/icons/{{ event.category | lowercase }}.svg" alt="Categorie icoontje" height="20" width="20">
      </div>
    </div>
  <div class="content">
    <div class="top">
      <div class="info">
        <p class="date_time"><i class="bi bi-calendar icon"></i> {{ event.start.toMillis() | date:'d MMM' }} <span class="separator">|</span>
          van {{ event.start.toMillis() | date:'H:mm' }}&nbsp;tot&nbsp;
          <span *ngIf="eventDateTime()">{{ event.end.toMillis() | date:'d MMM H:mm' }}</span>
          <span *ngIf="!eventDateTime()">{{ event.end.toMillis() | date:'H:mm' }}</span>
        </p>
        <span class="separator">|</span>
        <p class="location">
          <i class="bi bi-geo-alt icon"></i> {{ event.address.location }}
        </p>
      </div>
      <h1 class="title">{{ event.name }}</h1>
    </div>
    <div class="desc">{{ event.description | truncate:150 }}</div>

    <a [routerLink]="['/activiteit', event.id]">Bekijk activiteit <i class="bi bi-arrow-right"></i></a>
  </div>
</div>
